import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface DeleteReportResponse {
  success: boolean
  message?: string
}

export const useDeleteReport = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation<DeleteReportResponse, Error, string>({
    mutationFn: async (reportId: string) => {
      if (!reportId) {
        throw new Error('Report ID is required to delete report')
      }

      const response = await fetchWithAuth(`${URL}/reports/${reportId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      })

      return response
    },
    onSuccess: () => {
      // Invalidate and refetch reports list
      queryClient.invalidateQueries({ queryKey: ['reports'] })
    },
  })
}
